import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandJsaPage } from './cabsand-jsa';

@NgModule({
  declarations: [
    CabsandJsaPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandJsaPage),
  ],
})
export class CabsandJsaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-jsa/cabsand-jsa.module.ts